import { call, put, takeEvery } from "redux-saga/effects"

// Doctor Redux States
import { RESET_ZOOM_CREDENTIALS, GET_ZOOM_AUTH_URL } from "./actionTypes"
import {
  resetZoomCredentailSuccess,
  resetZoomCredentailFail,
  getZoomAuthURLSuccess,
  getZoomAuthURLFail,
} from "./actions"

//Include Both Helper File with needed methods
import { resetZoomCredentials, getZoomAuthURL } from "helpers/backend_helper"

// toast
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

function* onUpdateZoomCredentails({ payload: code }) {
  try {
    let request = {
      Code: code,
    }
    const response = yield call(resetZoomCredentials, request)
    yield put(resetZoomCredentailSuccess(response))
    toast.success("Zoom settings updated successfully", { autoClose: 2000 })
  } catch (error) {
    yield put(resetZoomCredentailFail(error))
  }
}

function* fetchZoomAuthURL() {
  try {
    const response = yield call(getZoomAuthURL)
    yield put(getZoomAuthURLSuccess(response))
  } catch (error) {
    yield put(getZoomAuthURLFail(error))
  }
}

function* zoomSaga() {
  yield takeEvery(RESET_ZOOM_CREDENTIALS, onUpdateZoomCredentails)
  yield takeEvery(GET_ZOOM_AUTH_URL, fetchZoomAuthURL)
}

export default zoomSaga
